export interface IBannerData {

}

export class BannerDataNull implements IBannerData {
    static NULL: BannerDataNull = new BannerDataNull();
}